import styled from "styled-components";
import { Switch } from 'antd';


export const ToggleSwitch = styled(Switch)`
.ant-switch[aria-checked="false"] {
}

`